<template>
  <div
    v-if="showButton"
    ref="filterBtn"
    class="filter-btn-container"
    :class="posiBtn ? 'position-btns' : 'filter-btns'"
    :style="{ left: !posiRight ? posi_left : '', right: posiRight ? 0 : '' }"
  >
    <span
      v-if="occultationForm && type !== 'top'"
      class="btns-more"
      @click="collapseFilter"
    >
      <i class="el-icon-caret-bottom" :style="{ transform: rotate }" />
      {{ filterControlText }}
    </span>
    <div class="filter-btn-list" :class="{ flexRCC: type === 'top' }">
      <!-- 查询 -->
      <el-tooltip
        v-model="tips"
        effect="dark"
        content="Ctrl + Enter"
        placement="top-start"
      >
        <el-button
          type="primary"
          @click.native.stop="filterSubmit(true, true)"
        >
          {{ $t("components.inquiry") }}
        </el-button>
      </el-tooltip>
      <!-- 重置 -->
      <el-button type="secondary" @click.native.stop="filterReset">
        {{ $t("components.reset") }}
      </el-button>
      <!-- 保存参数 -->
      <el-button
        v-if="paramsButton && !posiBtn"
        type="secondary"
        @click.native.stop="filterBtn('save')"
      >{{ $t("components.saveParameters") }}</el-button>
      <!-- 选择参数 -->
      <el-button
        v-if="paramsButton && !posiBtn"
        type="secondary"
        @click.native.stop="filterBtn('select')"
      >{{ $t("components.selectParameters") }}</el-button>
      <!-- 更多搜索 -->
      <el-button
        v-if="type === 'top' && occultationForm"
        type="secondary"
        @click.native.stop="collapseFilter"
      >{{ filterControlText }}</el-button>
      <div class="mr-12">
        <slot name="others-button" />
      </div>
    </div>

    <!-- 保存参数弹框 -->
    <local-dialog
      :append-to-body="true"
      :visible.sync="visible.save"
      :title="$t('components.saveParameters')"
      top="30vh"
      width="25%"
      :fullscreen="false"
      @close="handleClose('save')"
    >
      <template slot="content">
        <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent>
          <local-form-item
            :label="$t('grid.others.parameterNameKey')"
            prop="name"
            :custom-width="20"
            :error-msg="$t('grid.others.theParameterNameCannotBeEmpty')"
          >
            <el-input
              v-model="form.name"
              :placeholder="$t('grid.others.pleaseFillInTheParameterName')"
              size="mini"
              @keyup.native="tabCell"
            />
          </local-form-item>
        </el-form>
      </template>
      <template slot="footer">
        <el-button
          plain
          @click="handleClose('save')"
        >{{ $t("btns.cancel") }}
        </el-button>
        <el-button type="primary" @click="handleConfirm">{{
          $t("btns.confirmKey")
        }}</el-button>
      </template>
    </local-dialog>

    <!-- 选择参数弹框 -->
    <local-dialog-table
      ref="diaTable"
      :append-to-body="true"
      :title="$t('components.selectParameters')"
      width="550px"
      :select-all="false"
      :visible.sync="visible.select"
      :column-defs="columnDefs"
      :req-config="reqConfig"
      show-search
      @onSelect="onSelect"
    />
  </div>
</template>
<script>
import '../../../../lib/styles/components/FilterBtn.scss'
import { Format, MessageUtil, request } from '@cndinfo/cube-web-utils'
import TableBtn from './TableBtn'
import localDialog from '../../Dialog/index.js'
import localDialogTable from '../../DialogTable/index.js'
import localFormItem from '../../FormItem/index.js'
export default {
  name: 'FilterBtn',
  components: { localDialog, localDialogTable, localFormItem },
  props: {
    type: {
      type: String,
      default: 'bottom'
    },
    // form的model
    model: {
      type: Object,
      default: () => {}
    },
    // 参数控制按钮
    paramsButton: {
      type: Boolean,
      default: false
    },
    // 按钮保留
    showButton: {
      type: Boolean,
      default: false
    },
    posiRight: {
      type: Boolean,
      default: false
    },
    posiBtn: {
      type: Boolean,
      default: false
    },
    // 是否有隐藏
    occultationForm: {
      type: Boolean,
      default: false
    },
    // 点击更多不做操作
    readOnlyFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      posi_left: 0,
      isCollapse: false, // 是否展开更多查询条件
      filterControlText: this.$t('components.viewMore'),
      rotate: 'rotate(0deg)',
      markId: '',
      visible: {
        save: false,
        select: false
      },
      // 新增参数规则
      rules: {
        name: [
          {
            required: true,
            message: this.$t('grid.others.theParameterNameCannotBeEmpty'),
            trigger: 'change'
          }
        ]
      },
      // 新增参数form
      form: { name: '' },
      // 选择参数表头
      columnDefs: [
        {
          field: 'sParamType',
          headerName: this.$t('grid.others.parameterNameKey'),
          width: 377,
          maxWidth: 377
        },
        {
          headerName: this.$t('grid.others.operation'),
          width: 65,
          maxWidth: 65,
          cellRendererFramework: TableBtn,
          cellRendererParams: {
            update: () => {
              this.$refs.diaTable.queryTableList()
            }
          }
        }
      ],
      // 选择参数接口配置
      reqConfig: {
        url: '/paraminfo/page/{pageNo}/{pageSize}',
        method: 'post',
        params: {
          pageNo: 0,
          pageSize: 10,
          sPageCode: localStorage.getItem('menuId')
        },
        keyword: 'sParamType',
        dataFormat: {
          key: 'content',
          total: 'totalElements'
        }
      },
      saveParamRequest: {
        startTime: 0,
        endTime: 0
      },
      selectParamRequest: {
        startTime: 0,
        endTime: 0
      }
    }
  },
  watch: {
    'visible.save': function(value) {
      this.initParamTime(value, 'saveParamRequest')
    },
    'visible.select': function(value) {
      this.initParamTime(value, 'selectParamRequest')
    }
  },
  methods: {
    // 查看更多
    collapseFilter(state = true) {
      // 设置state为false还是允许事件触发
      if (this.readOnlyFilter && state) return
      this.filterControlText =
        this.filterControlText === this.$t('components.collapse')
          ? this.$t('components.viewMore')
          : this.$t('components.collapse')
      this.rotate =
        this.rotate === 'rotate(0deg)' ? 'rotate(180deg)' : 'rotate(0deg)'
      this.$emit('collapseFilter')
    },
    // 查询按钮
    filterSubmit() {
      this.$emit('submit')
    },
    // 重置按钮
    filterReset() {
      this.$emit('reset')
    },
    // 打开保存选择参数
    filterBtn(type) {
      this.visible[type] = true
    },
    // 关闭保存选择参数
    handleClose(type) {
      this.visible[type] = false
      this.$refs.form.resetFields()
    },
    // 保存参数键盘事件
    tabCell(e) {
      e.keyCode === 13 && this.handleConfirm()
    },
    // 确认保存
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            sPageCode: localStorage.getItem('menuId'),
            sParamType: this.form.name,
            sParamValue: JSON.stringify(Format.filterObj(this.model))
          }
          request({
            url: '/paraminfo/add',
            method: 'post',
            data: params,
            noLoading: true
          })
            .then((res) => {
              if (res.code !== '0000') return false
              this.handleClose('save')
              MessageUtil.success(this.$t('tips.saveSuccess'))
              this.saveParamRequest.endTime = new Date().getTime()
              try {
                window.collectEvent('advanced_search_save_params_click', {
                  is_success: 'true',
                  operate_time_cost:
                    this.saveParamRequest.endTime -
                    this.saveParamRequest.startTime
                })
              } catch (error) {
                console.log(error)
              }
            })
            .catch(() => {
              this.saveParamRequest.endTime = new Date().getTime()
              try {
                window.collectEvent('advanced_search_save_params_click', {
                  is_success: 'false',
                  operate_time_cost:
                    this.saveParamRequest.endTime -
                    this.saveParamRequest.startTime
                })
              } catch (e) {
                console.log(e)
              }
            })
        }
      })
    },
    // 确认选择参数
    onSelect(option, type) {
      this.visible.select = false

      if (type === 'confirm' && option && option?.length) {
        const { sParamValue } = option[0]

        this.$emit('filterAction', JSON.parse(sParamValue || '{}'))
        try {
          this.selectParamRequest.endTime = new Date().getTime()
          const operateTimeCost =
              this.selectParamRequest.endTime - this.selectParamRequest.startTime
          window.collectEvent('advanced_search_select_params_click', {
            operate_time_cost: operateTimeCost
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    // 初始化统计按钮的时间
    initParamTime(value, type) {
      if (value) {
        console.log('this[type]', value, type, this[type])
        this[type].startTime = new Date().getTime()
        this[type].endTime = 0
      }
    }
  }
}
</script>
